module.exports = __webpack_public_path__ + "img/logo-word.5237af76.png";